module.exports = __webpack_public_path__ + "img/预览icon.bd7f63c9.svg";